{
  "title": "حركات الإغلاق",
  "columns": {
    "number": "الرقم",
    "businessDate": "تاريخ العمل",
    "branch": "الفرع",
    "employee": "الموظف",
    "closeTime": "وقت الإغلاق",
    "notes": "ملاحظات"
  },
  "empty": {
    "noResults": "لا توجد نتائج",
    "noData": "لا توجد بيانات متاحة"
  }
}
